import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { PrimaryButton, SecondaryButton } from '../../components/atoms/Button';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify-icon/react';
import { useState } from 'react';

interface ToolAdd {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
  setFormData: any;
  formData: any;
  preview: any;
  setPreview: any;
}

function AddToolModal({
  open,
  onClose,
  onSaved,
  setFormData,
  formData,
  preview,
  setPreview,
}: ToolAdd) {
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      setFormData({
        ...formData,
        image: file,
      });

      setPreview(URL.createObjectURL(file));
    }
  };

  const removeImage = () => {
    setPreview(null);
    setFormData({
      ...formData,
      image: null,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{ borderRadius: 10, overflow: 'hidden' }}
      PaperProps={{
        sx: {
          borderRadius: 10,
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          border: '1px solid #E31E25',
          borderRadius: 10,
          overflow: 'hidden',
        }}
      >
        {/* {SnackbarComponent} */}
        <DialogTitle
          sx={{
            fontSize: '22px',
            fontWeight: 'bold',
            color: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#181818',
            padding: '16px',
          }}
        >
          {formData?.id ? 'Edit Tool' : 'Add Tool'}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ backgroundColor: '#181818', padding: '24px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography gutterBottom>Tool Name</Typography>
              <input
                className="border border-[#D9D9D9] rounded-[9px] w-full bg-transparent h-[55px] focus:outline-none focus:ring-0 placeholder:text-[#5a5e68] pl-3"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter Tool Name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography gutterBottom>Tool Code</Typography>
              <input
                className="border border-[#D9D9D9] rounded-[9px] w-full bg-transparent h-[55px] focus:outline-none focus:ring-0 placeholder:text-[#5a5e68] pl-3"
                name="code"
                value={formData.code || ''}
                onChange={handleChange}
                placeholder="Enter Tool Code (optional, auto-generated from name if left blank)"
              />
            </Grid>
            <Grid item xs={6}>
              <Typography gutterBottom>Tool Image</Typography>
              <input
                type="file"
                className="hidden"
                id="flieUpload"
                onChange={handleFileChange}
                disabled={!!preview}
              />

              <label
                htmlFor="flieUpload"
                className="flex cursor-pointer 
  border border-[#D9D9D9] rounded-[9px] h-[102px] w-full overflow-hidden relative"
              >
                {preview || formData.image ? (
                  <>
                    <img
                      src={preview || formData.image}
                      alt="preview"
                      className="h-full w-full object-cover"
                    />

                    {/* Close Button */}
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        removeImage();
                      }}
                      className="absolute top-1 right-1 bg-black/60 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                    >
                      ✕
                    </button>
                  </>
                ) : (
                  <div className="w-full flex flex-col justify-center items-center">
                    <Icon
                      icon="solar:camera-bold"
                      width="30"
                      height="30"
                      style={{ color: '#5a5e68' }}
                    />
                    <span className="text-[#5a5e68] text-[18px]">
                      Upload Image
                    </span>
                  </div>
                )}
              </label>
            </Grid>
            <Grid item xs={6}>
              <Typography gutterBottom>Description</Typography>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter Description..."
                className="border border-[#D9D9D9] rounded-[9px] h-[102px] w-full bg-transparent p-3 focus:outline-none focus:ring-0 placeholder:text-[#5a5e68]"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#181818', padding: '16px' }}>
          <DialogActions sx={{ backgroundColor: '#181818', padding: '16px' }}>
            <SecondaryButton title="Cancel" onClick={onClose} />
            <PrimaryButton title="Save" onClick={onSaved} />
          </DialogActions>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default AddToolModal;
